<template>
  <b-container class="custom-container p-0 pt-5 pb-5" v-if="user">
    <div class="page-title pt-5 mb-4">Welcome {{ user.first_name }}!</div>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser'
    })
  },

  async created() {
    await this.getAuthenticatedUser()

    /**
     * To be discussed since onboarding has
     * skip button that redirects to profile page
     **/
    // if (
    //   this.user &&
    //   !this.user.first_name &&
    //   !this.user.last_name &&
    //   !this.user.business_contact_number
    // ) {
    //   this.$router.replace({ name: 'auth.onboarding-page' })
    // }
  }
}
</script>
